import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_ARTICLE_PAGE_POPULAR_ARTICLE_PAGE = 'API_GET_LIST_ARTICLE_PAGE_POPULAR_ARTICLE_PAGE';
export const API_GET_LIST_ARTICLE_PAGE_POPULAR_PROFESSIONAL = 'API_GET_LIST_ARTICLE_PAGE_POPULAR_PROFESSIONAL';
/**
 * サイドバーの「週間ランキング」を取得
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiGetListArticlePagePopularArticlePage = (params, meta) => apiGetList(API_GET_LIST_ARTICLE_PAGE_POPULAR_ARTICLE_PAGE, '/article_page/popular', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/**
 * コラムサイドバーの「人気のコンサルタント」を取得
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiGetListArticlePagePopularProfessional = (params, meta) => apiGetList(API_GET_LIST_ARTICLE_PAGE_POPULAR_PROFESSIONAL, '/article_page/popular/professional', { keyword: params.query.keyword }, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
